<ng-container *ngIf="(jobStatus$ | async) as status">

  <div class="active-job-progress" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <div class='indeterminate-status-container' *ngIf="activeJobProgress.indeterminateMode" fxLayoutGap="15px"
         fxFlex="grow" fxFlexAlign="stretch" fxLayout="row"  fxLayoutAlign="end center">
      <div fxLayout="row" fxLayoutAlign="center center" class="spinner-panel">
        <mat-spinner diameter="45"></mat-spinner>
        <div class="timer-panel" *ngIf="status.started">
          {{status.started.toDate().getTime() |timeago}}
        </div>
       </div>
      <div class="status-panel">
        <div *ngIf="!activeJobProgress.cancelRequested; else cancelling">
            <span *ngIf="(backoffCountdown$ | async) as countdown; else showMessage">
            Google Classroom API quota limit reached. This is normal and further requests will process shortly. Waiting for {{countdown}} {{countdown > 1 ? 'seconds' : 'second'}} before retrying...
          </span>
          <ng-template #showMessage>
            <span>{{status.message}}</span>
          </ng-template>
        </div>
        <ng-template #cancelling>Cancelling...</ng-template>
      </div>
    </div>
      <div *ngIf="!activeJobProgress.indeterminateMode" class="status-container" fxFlex="grow" fxLayout="column" fxLayoutAlign="center center">
        <div class="progress" fxFlexAlign="stretch">
          <div class="label" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3px">
            <span>SYNC in progress</span>
            <span *ngIf="(activeSyncJob$ |async) as job">
              <ng-container *ngIf="job.name"> for {{job.name}}</ng-container>
            </span>
            <span *ngIf="(percentComplete$ | async) as progress">- {{progress}}</span>
            <span *ngIf="status.started">
            ({{status.started.toDate().getTime() | timeago}})
            </span>
          </div>
          <span class="value" *ngIf="(percentComplete$ | async) as w" [@slideLeftRight]="{value: status.progress, params: {width: w}}"></span>
        </div>
        <div *ngIf="!activeJobProgress.cancelRequested; else cancelling" class="status" fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="4px">
          <span *ngIf="(backoffCountdown$ | async) as countdown; else showMessage">
            Google Classroom API quota limit reached. This is normal and further requests will process shortly. Waiting for {{countdown}} {{countdown > 1 ? 'seconds' : 'second'}} before retrying...
          </span>
          <ng-template #showMessage>
            <span>Step {{status.phaseIndex}} of {{status.phasesTotal}}</span>
            <span>{{status.message}}</span>
          </ng-template>
        </div>
        <ng-template #cancelling>Cancelling...</ng-template>
      </div>
      <div fxFlex="0 1 auto">
        <button mat-button (click)="cancelActiveJob()" [disabled]="activeJobProgress.cancelRequested">Cancel</button>
      </div>
    </div>
</ng-container>
